// Значката на вида документ: ИЗПИСВАНЕ (неутрална) / БРАКУВАНЕ (червеникава) —
// същата форма като типа документ на доставката (DocTypeBadge).
import { useTranslation } from "react-i18next";
import type { WriteoffKind } from "./writeoffWorksheetShared";

export const WriteoffKindBadge = ({ kind }: { kind: WriteoffKind }) => {
  const { t } = useTranslation();
  return (
    <span
      className={`inline-flex shrink-0 items-center whitespace-nowrap rounded-[5px] px-[7px] py-0.5 text-[10.5px] font-bold uppercase leading-[normal] tracking-[0.06em] ${
        kind === "scrap" ? "bg-danger-tint text-danger-ink" : "bg-fill-2 text-body"
      }`}
    >
      {t(kind === "scrap" ? "inventoryPage.scrap" : "inventoryPage.writeoff")}
    </span>
  );
};

export default WriteoffKindBadge;
